module.exports = __webpack_public_path__ + "static/media/icon_89.2d6e41bc.svg";